// LogoContext.js
import React, { createContext, useState } from 'react';

export const LogoContext = createContext();

export const LogoProvider = ({ children }) => {
  const [logoUrl, setLogoUrl] = useState(localStorage.getItem('logo_url') || null);

  const updateLogoUrl = (newLogoUrl) => {
    setLogoUrl(newLogoUrl);
    localStorage.setItem('logo_url', newLogoUrl);
  };

  return (
    <LogoContext.Provider value={{ logoUrl, updateLogoUrl }}>
      {children}
    </LogoContext.Provider>
  );
};